import ValuationStepValidator from '@/interfaces/valuation/ValuationStepValidator'
import { ValuationStepData } from '@/interfaces/valuation/ValuationData'

export enum ValuationStepName {
  Property = 'property',
  Building = 'building',
  Locality = 'locality',
  Unit = 'unit',
}

export interface ValuationStep {
  name: ValuationStepName
  title: string
  data: ValuationStepData
  validator: ValuationStepValidator
}
